var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',[_c('v-card',[_c('v-card-title',[_vm._v("Dev Tools")]),_c('v-card-text',[_vm._v(" This is the Dev Tools view. ")])],1)],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }